import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from 'ngx-translate-with-country';
import { ResponsiveModule } from 'ngx-responsive';
import { SlickModule } from 'ngx-slick';

// import { OwlModule } from 'ngx-owl-carousel';
import { NgxFoundationModule } from './shared/ngx-foundation.module';

import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { HomeComponent } from './home/home.component';
import { DropdownDirective } from './shared/dropdown.directive';
import { AppRoutingModule } from './app-routing.module';
import { SupportBannerComponent } from './common/support-banner/support-banner.component';
import { FooterComponent } from './common/footer/footer.component';
import { LanguageBarComponent } from './common/header/language-bar/language-bar.component';
import { MainNavigationComponent } from './common/header/main-navigation/main-navigation.component';
import { SliderComponent } from './home/slider/slider.component';
import { DataStorageService } from './_services/data-storage.service';
import { SlidesService } from './home/slider/slides.service';
import { SearchProductsService } from './_services/searchProduct.service';
import { AlertComponent } from './shared/alert/alert.component';
import { IconComponent } from './shared/icon/icon.component';
import { ModalComponent } from './shared/modal/modal.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { CategoryComponent } from './category/category.component';
import { CategoryService } from './_services/category.service';
import { SupportComponent } from './support/support.component';
import { SearchProductComponent } from './search-product/search-product.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactComponent } from './contact/contact.component';
import { StaticService } from './_services/static.service';
import { ProductComponent } from './product/product.component';
import { ProductBreadcrumbComponent } from './product/product-breadcrumb/product-breadcrumb.component';
import { HighlightedTextComponent } from './product/highlighted-text/highlighted-text.component';
import { ImagesComponent } from './product/images/images.component';
import { ProductService } from './_services/product.service';
import { PageService } from './_services/page.service';
import { ContactService } from './_services/contact.service';
import { LocationService } from './_services/location.service';
import { PressReleaseService } from './_services/preleases.service';
import { CampaignService } from './_services/campaign.service';
import { SocialMediaService } from './_services/social-media.service';
import { FilterPipe } from './pipes/filter.pipe';
import { SafePipe } from './support/support-container/safe.pipe';
import { OrderByPipe } from './pipes/orderBy.pipe';
import { TrimPipes } from './pipes/trim.pipe';
import { CapitalizePipes } from './pipes/capitalize.pipe';
import { LowercasePipes } from './pipes/lowercase.pipe';
import { UppercasePipes } from './pipes/uppercase.pipe';
import { LanguageFilterPipe } from './pipes/language-filter.pipe';
import { StaticTextLoader } from './shared/staticText.loader';
// import { BreadcrumbModule } from 'angular-crumbs';
import { BreadcrumbsModule } from 'ng6-breadcrumbs';
import { DecodeHtmlStringPipe } from './pipes/decode-html-string.pipe';
import { KeepHtmlPipe } from './pipes/keep-html.pipe';
import { MobilNavigationComponent } from './common/header/mobil-navigation/mobil-navigation.component';
import { LanguagesComponent } from './common/languages/languages.component';
import { WheretobuyComponent } from './wheretobuy/wheretobuy.component';
import { AgmCoreModule } from '@agm/core';
import { MatchHeightDirective } from './shared/match-height.directive';
import { NgxPaginationModule } from 'ngx-pagination';
import { AngularResizedEventModule } from 'angular-resize-event';
import { PrivacyComponent } from './common/footer/privacy/privacy.component';
import { CookiePolicyComponent } from './common/footer/cookie-policy/cookie-policy.component';
import { TermsConditionsComponent } from './common/footer/terms-conditions/terms-conditions.component';
import { ForLifeComponent } from './common/footer/for-life/for-life.component';
import { SimpleSmoothScrollModule } from 'ng2-simple-smooth-scroll';
import { CategorySummaryComponent } from './home/category-summary/category-summary.component';
import { PageConnectionsComponent } from './home/page-connections/page-connections.component';
import { ProductAreaComponent } from './product-area/product-area.component';
import { SupportContainerComponent } from './support/support-container/support-container.component';
import { AreaBannerComponent } from './product-area/area-banner/area-banner.component';
import { AboutComponent } from './about/about.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ProductModal } from './_services/product-modal.service';
import { CorporateMissionComponent } from './press-release/corporate-mission/corporate-mission.component';
import { MediaCenterComponent } from './press-release/media-center/media-center.component';
import { NewsroomComponent } from './press-release/newsroom/newsroom.component';
import { NewsComponent } from './press-release/news/news.component';
import { Lightbox, LightboxModule } from 'ngx-lightbox';
import { RegisterProductComponent } from './support/register-product/register-product.component';
import { MyDatePickerModule } from 'mydatepicker';
import { ProductRegisterService } from './_services/product-register.service';
import { LogosComponent } from './press-release/media-center/logos/logos.component';
import { ByCategoryComponent } from './press-release/media-center/by-category/by-category.component';
import { ByModelComponent } from './press-release/media-center/by-model/by-model.component';
import { BrochuresComponent } from './press-release/media-center/brochures/brochures.component';
import { ProductImagesComponent } from './press-release/media-center/by-category/product-images/product-images.component';
import { HighResolutionComponent } from './press-release/media-center/by-category/product-images/high-resolution/high-resolution.component';
import { SearchByModelService } from './press-release/media-center/by-model/bymodel-service';
import { ModalService } from './_services/modal.service';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  observer: true,
  direction: 'horizontal',
  slidesPerView: 1,
  keyboard: true,
  mousewheel: true,
  scrollbar: false,
  navigation: true,
  pagination: true,
  threshold: 0,
  autoplay: {
    delay: 10000
  }
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    DropdownDirective,
    SafePipe,
    SupportBannerComponent,
    FooterComponent,
    LanguageBarComponent,
    MainNavigationComponent,
    SliderComponent,
    AlertComponent,
    IconComponent,
    ModalComponent,
    CategoryComponent,
    SupportComponent,
    SearchProductComponent,
    ContactComponent,
    ProductComponent,
    ProductBreadcrumbComponent,
    HighlightedTextComponent,
    ImagesComponent,
    FilterPipe,
    CapitalizePipes,
    LowercasePipes,
    UppercasePipes,
    LanguageFilterPipe,
    DecodeHtmlStringPipe,
    KeepHtmlPipe,
    OrderByPipe,
    TrimPipes,
    MobilNavigationComponent,
    LanguagesComponent,
    WheretobuyComponent,
    MatchHeightDirective,
    PrivacyComponent,
    CookiePolicyComponent,
    TermsConditionsComponent,
    ForLifeComponent,
    CategorySummaryComponent,
    PageConnectionsComponent,
    ProductAreaComponent,
    SupportContainerComponent,
    AreaBannerComponent,
    AboutComponent,
    NotFoundComponent,
    CorporateMissionComponent,
    MediaCenterComponent,
    NewsroomComponent,
    NewsComponent,
    RegisterProductComponent,
    LogosComponent,
    ByCategoryComponent,
    ByModelComponent,
    BrochuresComponent,
    ProductImagesComponent,
    HighResolutionComponent,
  ],
  imports: [
BrowserModule,
    AppRoutingModule,
    // HttpModule,
    BreadcrumbsModule,
    MyDatePickerModule ,
    HttpClientModule,
    SwiperModule,
    HttpModule,
    SwiperModule,
    LightboxModule,
    FormsModule,
    AngularResizedEventModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    SimpleSmoothScrollModule, 
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCB_6e7dyGjbNfcVQKb_fTbCPE1ol3GORw',
      libraries: ['places']
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        // useFactory: HttpLoaderFactory,
        // deps: [HttpClient],
        useClass: StaticTextLoader,
      }
    }),
    ResponsiveModule.forRoot(),
    SlickModule.forRoot(),
    NgxFoundationModule
  ],
  providers: [
    ProductModal,
    DataStorageService,
    SearchProductsService,
    SlidesService,
    StaticService,
    CategoryService,
    PageService,
    CampaignService,
    LocationService,
    ContactService,
    ProductService,
    OrderByPipe,
    SocialMediaService,
    PressReleaseService,
    ProductRegisterService,
    ImagesComponent,
    ModalService,
    SearchByModelService,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }],
  bootstrap: [AppComponent],
  exports: [
    OrderByPipe
  ]
})
export class AppModule { }
